import React from 'react';
import PropTypes from 'prop-types';
import {sortedUniq} from 'lodash';

function FacetValues({facet, value}) {
	if (!facet) {
		return null;
	}

	let propertyValues = Object.values(facet.properties).map(prop => prop[value]);
	propertyValues = sortedUniq(propertyValues.sort());

	return (
		<span>
			{propertyValues.join(', ')}
		</span>
	);
}

FacetValues.propTypes = {
	facet: PropTypes.object,
	value: PropTypes.string.isRequired,
};

export default React.memo(FacetValues);
